import { injectReducer } from "../../store/reducers";
import { isLoggedIn } from "../../utils/auth";
import {
  loadCustomerOffersReducer,
  validateOTPReducer,
  generateOTPReducer
} from "./modules/OfferActivation";

export default (store) => ({
  path: "offer-activation",
  onEnter: isLoggedIn(store),
  /*  Async getComponent is only invoked when route matches   */
  getComponent(nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure(
      [],
      (require) => {
        /*  Webpack - use require callback to define
          dependencies for bundling   */
        const CustomerDetails = require("./containers/OfferActivation").default;
        injectReducer(store, {
          key: "customerOffers",
          reducer: loadCustomerOffersReducer,
        });
        injectReducer(store, {
          key: "validatedOtpInfo",
          reducer: validateOTPReducer,
        });
        injectReducer(store, {
          key: "otpInfo",
          reducer: generateOTPReducer,
        });
        cb(null, CustomerDetails);
        /* Webpack named bundle   */
      },
      "offerActivation"
    );
  },
});



// WEBPACK FOOTER //
// ./src/routes/OfferActivation/index.js